// removed by extract-text-webpack-plugin
module.exports = {"ColorField":"i8Mq9CkW9Lp1L-eOmrenP"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/Leave/index.css
// module id = 959
// module chunks = 0